import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faArrowLeft, faAngleDown, faAngleUp, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import BookingCancel from './BookingCancel';
import KeyList from '../userkeys/UserkeyList';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import { dateFormatter } from '../../../lib/formatter';

const BookingDetail = ({
  bookingId,
  countryInfoList,
  countryNumber,
  selectedBuildingName,
  selectedRoomName,
  bookingUpdateItem,
  userkeyListItems,
  setCountryNumber,
  setBookingUpdateItem,
  selectBookingApi,
  updateBookingApi,
  moveToListPage,
  history,
}) => {
  const { t } = useTranslation();
  const [ isOpenBookingCancelModal, setIsOpenBookingCancelModal ] = useState(false);
  const [ isOpenBookingUpdateSuccessModal, setIsOpenBookingUpdateSuccessModal ] = useState(false);
  const [ isOpenBookingUpdateFailModal, setIsOpenBookingUpdateFailModal ] = useState(false);
  const [ messageBookingUpdateFail, setMessageBookingUpdateFail ] = useState('');
  const [ isActiveBookingInfoTab, toggleBookingInfoTab ] = useState(true);
  const [ isActiveKeyListTab, toggleKeyListTab ] = useState(true);

  const updateBooking = async () => {
    try {
      await updateBookingApi();
      setIsOpenBookingUpdateSuccessModal(true);
      setTimeout(() => {
        setIsOpenBookingUpdateSuccessModal(false);
        selectBookingApi();
      }, 1500);
    } catch (error) {
      if (!error.response) setMessageBookingUpdateFail(error.message);
      else setMessageBookingUpdateFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenBookingUpdateFailModal(true);
    }
  };

  return (
    <Fragment>
      <div className='content-title2'>
        <h3>
          <span onClick={moveToListPage}><FontAwesomeIcon icon={faArrowLeft}/></span>
          {t('content_title.booking_detail')}
        </h3>
      </div>
      <div className='content-title'></div>
      <div className='form-tab'>
        <p className='tab-item'>{t('tab_column.booking_detail')}</p>
      </div>
      <div className='form-card detail tab'>
        <div className='form-card-title detail'>
          <div className='form-dropdown detail first' onClick={() => setIsOpenBookingCancelModal(true)}>
            <span><FontAwesomeIcon icon={faTrashAlt}/></span>
          </div>
          <div className='form-toggle-btn' onClick={() => toggleBookingInfoTab(!isActiveBookingInfoTab)}>
            <span hidden={isActiveBookingInfoTab}><FontAwesomeIcon icon={faAngleDown}/></span>
            <span hidden={!isActiveBookingInfoTab}><FontAwesomeIcon icon={faAngleUp}/></span>
          </div>
        </div>
        <div hidden={!isActiveBookingInfoTab}>
          <div className='inline-flex'>
            <div className='w-50'>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faBuilding}/> */}
                  <b>{t('data_column.building')}</b>
                </p>
                <input
                  className='card-text-input'
                  value={selectedBuildingName || '-'}
                  disabled
                />
              </div>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faBed}/> */}
                  <b>{t('data_column.room')}</b>
                </p>
                <input
                  className='card-text-input'
                  value={selectedRoomName || '-'}
                  disabled
                />
              </div>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faUserAlt}/> */}
                  <b>{t('data_column.user_name')}</b>
                  <span className='required'>*</span>
                </p>
                <input
                  className='card-text-input'
                  placeholder={t('placeholder.user_name')}
                  value={bookingUpdateItem.userName}
                  onChange={e => setBookingUpdateItem({...bookingUpdateItem, userName:e.target.value})}
                />
              </div>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faPhone}/> */}
                  <b>{t('data_column.phone_number')}</b>
                  <span className='required'>*</span>
                </p>
                <select
                  className='card-text-select'
                  value={countryNumber}
                  onChange={e => setCountryNumber(e.target.value)}
                >
                  {countryInfoList.map((country, index) => (
                    <option key={`country-index-${index}`} value={country.phone}>{`${country.name} ( +${country.phone} )`}</option>
                  ))}
                </select>
                <p></p>
                <input
                  className='card-text-input'
                  placeholder={t('placeholder.phone_number')}
                  value={bookingUpdateItem.phoneNumber}
                  maxLength='11'
                  onChange={e => setBookingUpdateItem({...bookingUpdateItem, phoneNumber:e.target.value})}
                />
              </div>
            </div>
            <div className='w-50'>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faHourglassStart}/> */}
                  <b>{t('data_column.checkin_at')}</b>
                  <span className='required'>*</span>
                </p>
                <DatePicker
                  dateFormat='yyyy-MM-dd HH:mm'
                  placeholderText={t('placeholder.checkin_at')}
                  selected={bookingUpdateItem.checkinAt}
                  selectsStart
                  minDate={new Date()}
                  endDate={bookingUpdateItem.checkoutAt}
                  showTimeSelect
                  timeFormat='HH:mm'
                  timeIntervals={60}
                  timeCaption='Time'
                  onChange={date => setBookingUpdateItem({...bookingUpdateItem, checkinAt:date})}
                  withPortal
                />
              </div>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faHourglassEnd}/> */}
                  <b>{t('data_column.checkout_at')}</b>
                  <span className='required'>*</span>
                </p>
                <DatePicker
                  disabled={!bookingUpdateItem.checkinAt}
                  dateFormat='yyyy-MM-dd HH:mm'
                  placeholderText={t('placeholder.checkout_at')}
                  selected={bookingUpdateItem.checkoutAt}
                  selectsEnd
                  minDate={bookingUpdateItem.checkinAt}
                  startDate={bookingUpdateItem.checkinAt}
                  showTimeSelect
                  timeFormat='HH:mm'
                  timeIntervals={60}
                  timeCaption='Time'
                  onChange={date => setBookingUpdateItem({...bookingUpdateItem, checkoutAt:date})}
                  withPortal
                />
              </div>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faClipboard}/> */}
                  <b>{t('data_column.description')}</b>
                </p>
                <input
                  className='card-text-input'
                  placeholder={t('placeholder.description_booking')}
                  value={bookingUpdateItem.desc}
                  onChange={e => setBookingUpdateItem({...bookingUpdateItem, desc:e.target.value})}
                />
              </div>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faHammer}/> */}
                  <b>{t('data_column.created_at')}</b>
                </p>
                <input
                  className='card-text-input'
                  value={dateFormatter(bookingUpdateItem.createdAt)}
                  disabled
                />
              </div>
              <div className='card-text'>
                <p>
                  {/* <FontAwesomeIcon icon={faWrench}/> */}
                  <b>{t('data_column.updated_at')}</b>
                </p>
                <input
                  className='card-text-input'
                  value={dateFormatter(bookingUpdateItem.updatedAt)}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className='card-foot'>
            <div className='form-item-cancel'>
              <button className='btn-item-cancel' onClick={moveToListPage}>
                <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>{t('button.cancel')}</span>
              </button>
            </div>
            <div className='form-item-add center detail'>
              <button className='btn-item-add' onClick={updateBooking}>
                <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>{t('button.save')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='form-tab-wrap'>
        <div className='form-tab'>
          <p className='tab-item'>{t('tab_column.userkey_list')}</p>
        </div>
        <div className='form-tab-item'>
          <div className='form-card-title detail'>
            <div className='form-toggle-btn' onClick={() => toggleKeyListTab(!isActiveKeyListTab)}>
              <span hidden={isActiveKeyListTab}><FontAwesomeIcon icon={faAngleDown}/></span>
              <span hidden={!isActiveKeyListTab}><FontAwesomeIcon icon={faAngleUp}/></span>
            </div>
          </div>
          <div className='form-key-foot' hidden={!isActiveKeyListTab}>
            <KeyList
              bookingId={bookingId}
              roomName={selectedRoomName}
              userkeyListItems={userkeyListItems}
              reload={selectBookingApi}
              history={history}
            />
          </div>
        </div>
      </div>
      <BookingCancel
        isOpen={isOpenBookingCancelModal}
        toggle={() => setIsOpenBookingCancelModal(!isOpenBookingCancelModal)}
        reload={() => moveToListPage()}
        bookingId={bookingId}
      />
      <ResponseSuccessModal
        isOpen={isOpenBookingUpdateSuccessModal}
        toggle={() => setIsOpenBookingUpdateSuccessModal(!isOpenBookingUpdateSuccessModal)}
        message='예약 정보 수정이 완료 되었습니다.'
      />
      <ResponseFailModal
        isOpen={isOpenBookingUpdateFailModal}
        toggle={() => setIsOpenBookingUpdateFailModal(!isOpenBookingUpdateFailModal)}
        message={messageBookingUpdateFail || '예약 정보 수정에 실패 하였습니다.'}
      />
    </Fragment>
  );
};

export default BookingDetail;